import { invalidTacticUpdateParser } from './invalidTacticUpdateParser';
import { invalidTacticValidationParser } from './invalidTacticValidationParser';
import { userActionParser } from './userActionParser';

/**
 *
 * @param {*} notificationDetails
 * @returns an object containing an errorType. The error types can be:
 * 1) TRADE_PLAN_ERROR-> an error related to a tradePlan
 * 2) USER_ACTION -> an error that comes with a user action. This will be sent to a user action parser to add related fields.
 * 3) ORDER_VALIDATION -> an error related to an attempted order. In these cases, the order doesn't actually
 * go through, but is blocked by TU. something like we believe your action will result in 15 qty of closing orders,
 * when the position only has 10 qty
 * 4) SYSTEM_ERROR -> when the system has an error. much more general type of error if I remember correctly
 * 5) TACTIC_VALIDATION -> any error that relates to a validating a tactic. Can relate to automatic exits, invalid settings, etc. As of now,
 * this will be sent to another parser that will add the tactic name to our parsed Object
 * 6) ORDER_ERROR -> these are errors that occur with orders actually placed with tradier
 * 7) INVALID_TACTIC_UPDATE -> when an attempt to update a tactic fails
 *
 */
export function errorTemplateParser(notificationDetails) {
  let parsedObject = {
    errorType: null,
  };

  if (notificationDetails) {
    parsedObject.errorType = notificationDetails.errorType;
    if (parsedObject.errorType === 'USER_ACTION') {
      parsedObject = userActionParser(notificationDetails, parsedObject);
    }
    if (parsedObject.errorType === 'INVALID_TACTIC_UPDATE') {
      parsedObject = invalidTacticUpdateParser(
        notificationDetails,
        parsedObject
      );
    }
    if (parsedObject.errorType === 'TACTIC_VALIDATION') {
      parsedObject = invalidTacticValidationParser(
        notificationDetails,
        parsedObject
      );
    }
  }
  return parsedObject;
}
